import Api from '../../../common/services/api';
import { getNetworkIdForUser } from './utils/get-network-id-for-user';

export const NETWORK_DELETE_USER = 'network/DELETE_USER';

const deleteNetworkUser = (userId) => (dispatch, getState) => {
  const { organisation: { selected } } = getState();
  const networkId = getNetworkIdForUser(userId, getState);

  dispatch({
    type: NETWORK_DELETE_USER,
    userId,
    networkId,
  });

  // Always delete at organisation-level, even from community dashboards.
  // Backend must allow community-level permissions for this org-level delete.
  return Api.delete(`/v2/organisations/${selected.id}/users/${userId}`);
};

export default deleteNetworkUser;
